<template>
  <el-image 
    v-bind="this.$props" 
    @load="loading = false"  
    @error="loading = false"
    :class="{'loading': loading}">
    <span slot="placeholder" class="placeholder">图片加载中...</span>
  </el-image>
</template>

<script>
import { Image } from 'element-ui'
export default {
  data(){
    return {
      loading: true
    }
  },
  props: Image.props,
  watch: {
    src(val){
      this.loading = true;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-image{
  display: inline-block;
  box-shadow: 0 0 0.035rem rgba(0,0,0,.2);

  &.loading{
    box-shadow: initial;
    min-height: 0.35rem;
  }

  .placeholder{
    color: $text3;
  }

  >>> .el-image__inner{
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyImage.vue